(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zhopu-category-picks"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('zhopu-category-picks')){
    customElements.define('zhopu-category-picks',class extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        const track=this.querySelector('.zhopu-related__track');
        const template=this.querySelector('[data-picks-card]');
        const seen=new Set();
        this.querySelectorAll('[data-picks-pool]').forEach(pool=>{
          const data=JSON.parse(pool.textContent);
          const unique=data.items.filter(item=>!seen.has(item.id));
          const candidates=unique.length?unique:data.items;
          if(!candidates.length)return;
          const item=candidates[Math.floor(Math.random()*candidates.length)];
          seen.add(item.id);
          const card=template.content.cloneNode(true);
          card.querySelectorAll('a').forEach(link=>link.href=item.url);
          card.querySelector('[name="id"]').value=item.variantId;
          card.querySelector('[name="quantity"]').value=item.quantity;
          card.querySelector('h3').textContent=item.title;
          card.querySelector('strong').textContent=item.price;
          card.querySelector('img').src=item.image;
          card.querySelector('img').alt=item.title;
          card.querySelector('.zhopu-category-picks__category').textContent=data.category;
          track.append(card);
        });
        if(!track.children.length)return;
        this.hidden=false;
        const prev=this.querySelector('[data-picks-prev]');
        const next=this.querySelector('[data-picks-next]');
        const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};
        const move=direction=>{
          const step=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
          track.scrollBy({left:direction*step*Math.max(1,Math.floor(track.clientWidth/step)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        };
        this.events=new AbortController();const options={signal:this.events.signal};
        prev.addEventListener('click',()=>move(-1),options);next.addEventListener('click',()=>move(1),options);
        track.addEventListener('scroll',update,{...options,passive:true});
        track.addEventListener('keydown',event=>{if(event.target===track&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}},options);
        this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update();
      }
      disconnectedCallback(){this.events?.abort();this.resizeObserver?.disconnect();this.initialized=false;this.querySelector('.zhopu-related__track')?.replaceChildren()}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zhopu-related-products"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('zhopu-related-products')){
    customElements.define('zhopu-related-products',class extends HTMLElement{
      connectedCallback(){
        this.bindCarousel();
        if(this.dataset.localMatches==='true')return;
        this.observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){
            this.observer.disconnect();
            this.loadRecommendations();
          }
        },{rootMargin:'300px'});
        this.observer.observe(this);
      }
      disconnectedCallback(){this.observer?.disconnect();this.resizeObserver?.disconnect();this.events?.abort()}
      async loadRecommendations(){
        try{
          const response=await fetch(this.dataset.url);
          if(!response.ok)return;
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const content=html.querySelector('zhopu-related-products [data-related-content]');
          if(!this.isConnected||!content?.querySelector('.zhopu-related__item'))return;
          this.querySelector('[data-related-content]').replaceWith(content);
          this.bindCarousel();
        }catch{}
      }
      bindCarousel(){
        this.events?.abort();this.resizeObserver?.disconnect();
        this.events=new AbortController();
        const options={signal:this.events.signal};
        const track=this.querySelector('.zhopu-related__track');
        const previous=this.querySelector('[data-related-prev]');
        const next=this.querySelector('[data-related-next]');
        if(!track||!previous||!next)return;
        const update=()=>{
          previous.disabled=track.scrollLeft<=2;
          next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
        };
        const move=direction=>{
          const first=track.querySelector('li');
          if(!first)return;
          const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
          const count=Math.max(1,Math.floor(track.clientWidth/step));
          track.scrollBy({left:direction*step*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        };
        previous.addEventListener('click',()=>move(-1),options);
        next.addEventListener('click',()=>move(1),options);
        track.addEventListener('scroll',update,{...options,passive:true});
        track.addEventListener('keydown',event=>{
          if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;
          event.preventDefault();move(event.key==='ArrowRight'?1:-1);
        },options);
        this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
